import React from 'react';
import { AccordionBodyItemView } from 'component/Accordion';
import { ReactComponent as CheckBoxIcon } from 'assets/images/icons/check_box_24(1).svg';

export const AttackUavView = (props) => {
  const { formData } = props;

  return (
    <AccordionBodyItemView
      accordionSubId="3.10"
      titleUA="Ударні БПЛА, частини ударних БПЛА"
      titleEN="Attack UAV and parts"
      children={
        formData.info.hazard_type.attack_uav && (
          <CheckBoxIcon />
        )
      }
    />
  );
};
